export default __webpack_public_path__ + "static/media/google-link.f902960a.png";